export { NotificationGatewayClient } from './notification-gateway.client';
